import React from "react";
import ProductCard from "./ProductCard";
import { useVariant } from "../../context/variant/VariantContext";
import PaymentPromo from "../paymentPromo/PaymentPromo";
import { getPrimaryVariant } from "../../utils/product";
import PropTypes from "prop-types";
import { useProduct } from "../../context/product/ProductContext";
import saveForLater from "../../utils/saveForLater";
import { PAGE_AREAS } from "../../constants";
import { PrimaryPrice } from "../priceComponents";
import ShowOnProductStockStatus from "../conditional/ShowOnProductStockStatus";
import { COMPLEMENTARY_PRIMARY_PRICE } from "../priceComponents/priceTypes";
import Rating from "../ratingComponents/rating/Rating";
import DeliveryAndReturnsContainer from "../../containers/deliveryAndReturnsContainer/DeliveryAndReturnsContainer";
import {
  fireAddToBagAnalytics,
  fireAddToBagErrorAnalytics,
} from "../../analytics/addToBag";
import {
  fireSaveForLaterMarketing,
  fireAddToBagMarketing,
} from "../../utils/marketingTracking/marketingTrackingEvents";
import fireNotifyMeClickAnalytics from "../../analytics/backInStock";
import EarlyAccessToProductLabel from "../earlyAccessToProductLabel/EarlyAccessToProductLabel";

export default function MixAndMatchProductCard({ index }) {
  const { product } = useProduct();
  const { selectedVariant } = useVariant();

  if (!product) {
    return null;
  }

  const defaultColourWayId = getPrimaryVariant(product.variants).colourWayId;
  const variantIdentifier = selectedVariant
    ? `variantId:${selectedVariant.variantId}`
    : `colourWayId:${defaultColourWayId}`;

  const handleSaveClick = (event) => {
    event.stopPropagation();
    event.preventDefault();

    const identifier = selectedVariant
      ? { variantId: selectedVariant.variantId }
      : { colourWayId: defaultColourWayId };

    saveForLater({
      product: product,
      items: [{ productId: product.id, ...identifier }],
      pageArea: PAGE_AREAS.MAIN,
    });

    fireSaveForLaterMarketing({
      product,
      variantsAdded: selectedVariant ? [selectedVariant] : product.variants,
    });
  };

  return (
    <>
      <ProductCard
        product={product}
        handleSaveClick={handleSaveClick}
        productLink={product.url}
        variantIdentifier={variantIdentifier}
        variantSelectorId={`mixAndMatchVariantSelector-${index}`}
        fireAddToBagAnalytics={fireAddToBagAnalytics}
        fireAddToBagErrorAnalytics={fireAddToBagErrorAnalytics}
        fireAddToBagMarketing={fireAddToBagMarketing}
        fireNotifyMeClickAnalytics={fireNotifyMeClickAnalytics}
        primaryImageUrl={product.productImage.url}
        imageWidth={163}
        shouldRetainSmallImageSize={true}
        priceRenderProp={() => (
          <>
            <PrimaryPrice
              priceData={product.price}
              testId="product-price"
              priceType={COMPLEMENTARY_PRIMARY_PRICE}
            />
            <ShowOnProductStockStatus productStockStatus={true}>
              <PaymentPromo priceValue={product.price.current.value} />
            </ShowOnProductStockStatus>
          </>
        )}
        ratingRenderProp={() => (
          <Rating
            ratingsFromProduct={product.ratings}
            productLink={product.url}
            isInStock={product.isInStock}
          />
        )}
        labelsRenderProp={() => <EarlyAccessToProductLabel />}
      />
      <DeliveryAndReturnsContainer />
    </>
  );
}

MixAndMatchProductCard.propTypes = {
  index: PropTypes.number.isRequired,
};
